/**
 * Convert BlockNumber | BlockTag to the format expected by RPC calls
 *
 * @param blockTag - Block number (bigint) or block tag string to convert
 * @returns Hex-encoded block number or the original block tag, defaults to 'latest'
 */
export function convertBlockTagToRpc(blockTag) {
    return blockTag !== undefined
        ? typeof blockTag === 'bigint'
            ? `0x${blockTag.toString(16)}`
            : blockTag
        : 'latest';
}
